(function () {
  var templateSelector = '[data-mobile-nav-template]';
  var desktopQuery = window.matchMedia('(min-width: 1024px)');

  function navigationIsOpen(navigation) {
    if (desktopQuery.matches || navigation.classList.contains('animating-out')) return false;

    return (
      navigation.classList.contains('visible') ||
      navigation.classList.contains('animating-in')
    );
  }

  /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
  function navigationKeepsWidgetsHidden(navigation) {
    return Boolean(
      !desktopQuery.matches &&
      navigation &&
      navigation.isConnected &&
      navigation.__kkDisclosureUnloading !== true &&
      (
        navigation.classList.contains('visible') ||
        navigation.classList.contains('animating-in') ||
        navigation.classList.contains('animating-out')
      )
    );
  }

  function syncMobileNavigationWidgetLayering() {
    var keepsWidgetsHidden = Array.prototype.some.call(
      document.querySelectorAll('[data-mobile-nav]'),
      navigationKeepsWidgetsHidden
    );

    if (document.body) {
      document.body.classList.toggle('kk-mobile-nav-open', keepsWidgetsHidden);
    }
  }
  /* KK_MOBILE_NAV_WIDGET_LAYERING_END */

  function isVisibleFocusTarget(element) {
    return Boolean(
      element &&
      element.isConnected &&
      typeof element.focus === 'function' &&
      !element.hidden &&
      !element.disabled &&
      element.getAttribute('aria-hidden') !== 'true' &&
      (element.offsetParent !== null || element.getClientRects().length > 0)
    );
  }

  function focusWithoutScroll(element) {
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function focusMobileNavigation(navigation) {
    window.requestAnimationFrame(function () {
      if (!navigation.isConnected || !navigationIsOpen(navigation)) return;

      var close = navigation.querySelector('[data-mobile-nav-close]');
      var target = isVisibleFocusTarget(close) ? close : navigation;
      if (document.activeElement === target) return;
      focusWithoutScroll(target);
    });
  }

  function recoverFocusAfterClose(header, navigation, toggle) {
    var active = document.activeElement;
    if (!active || (!navigation.contains(active) && active !== document.body && active !== document.documentElement)) return;

    var target = !desktopQuery.matches ?
      toggle :
      header.querySelector('.site-logo[href], .site-logo a[href], .site-logo-link[href]');
    if (isVisibleFocusTarget(target)) focusWithoutScroll(target);
  }

  function syncDisclosure(header) {
    if (!header) return;

    var toggle = header.querySelector('[data-menu-toggle]');
    var navigation = header.querySelector('[data-mobile-nav]');
    var isOpen;
    var wasOpen;
    if (!toggle || !navigation) return;

    if (!navigation.id) navigation.id = 'site-mobile-nav';
    isOpen = navigationIsOpen(navigation);
    wasOpen = navigation.__kkDisclosureOpen === true;
    navigation.__kkDisclosureOpen = isOpen;

    /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
    syncMobileNavigationWidgetLayering();
    /* KK_MOBILE_NAV_WIDGET_LAYERING_END */

    if (wasOpen && !isOpen) recoverFocusAfterClose(header, navigation, toggle);

    toggle.setAttribute('aria-controls', navigation.id);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    navigation.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) navigation.removeAttribute('inert');
    else navigation.setAttribute('inert', '');

    if (isOpen && !wasOpen) focusMobileNavigation(navigation);

    if (navigation.__kkDisclosureObserved) return;
    navigation.__kkDisclosureObserved = true;

    new MutationObserver(function () {
      syncDisclosure(header);
    }).observe(navigation, { attributes: true, attributeFilter: ['class'] });
  }

  function syncAllDisclosures(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-site-header]')) syncDisclosure(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-site-header]'), syncDisclosure);
  }

  function hydrate(header) {
    if (!header) return false;

    var templates = header.querySelectorAll(templateSelector);
    if (!templates.length) return false;

    Array.prototype.forEach.call(templates, function (template) {
      if (!template.content || !template.parentNode) return;

      var content = template.content.cloneNode(true);
      template.parentNode.insertBefore(content, template);
      template.parentNode.removeChild(template);
    });

    header.setAttribute('data-mobile-nav-hydrated', 'true');
    syncDisclosure(header);
    return true;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var toggle = target.closest('[data-menu-toggle]');
    if (!toggle) return;

    var header = toggle.closest('[data-site-header]');
    hydrate(header);
    syncDisclosure(header);
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    syncAllDisclosures(event.target);
  });

  /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
  document.addEventListener('shopify:section:unload', function (event) {
    var navigation = event.target && event.target.querySelector ?
      event.target.querySelector('[data-mobile-nav]') :
      null;

    if (!navigation) return;
    navigation.__kkDisclosureUnloading = true;
    document.body.classList.remove('kk-mobile-nav-open');
    window.setTimeout(syncMobileNavigationWidgetLayering, 0);
  });
  window.addEventListener('pagehide', function () {
    if (document.body) document.body.classList.remove('kk-mobile-nav-open');
  });
  window.addEventListener('pageshow', function () {
    syncAllDisclosures(document);
    syncMobileNavigationWidgetLayering();
  });
  /* KK_MOBILE_NAV_WIDGET_LAYERING_END */

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', function () { syncAllDisclosures(document); });
    /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
    desktopQuery.addEventListener('change', syncMobileNavigationWidgetLayering);
    /* KK_MOBILE_NAV_WIDGET_LAYERING_END */
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(function () { syncAllDisclosures(document); });
    /* KK_MOBILE_NAV_WIDGET_LAYERING_START */
    desktopQuery.addListener(syncMobileNavigationWidgetLayering);
    /* KK_MOBILE_NAV_WIDGET_LAYERING_END */
  }

  syncAllDisclosures(document);

  window.KKMobileNav = window.KKMobileNav || {};
  window.KKMobileNav.hydrate = hydrate;
}());
